// extracted by mini-css-extract-plugin
export default {"card":"CardVisitas_card__Yun6A","container":"CardVisitas_container__cGtpc"};